import { useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { GetVideos, GetProducts, GetUnfilteredVideos } from "./queries";
import {
  buildFilterOptions,
  buildGetVideosVariables,
  mapDataToVideos
} from "./helpers";

export function useVideoList({ filters, scheduled, searchText, isArchived, onUnarchiveVideo, onAddToReport }) {
  const { loading, data, refetch } = useQuery(
    GetVideos,
    buildGetVideosVariables({filters, scheduled, searchText, isArchived})
  );

  return {
    loading,
    refetchVideos: refetch,
    videos: mapDataToVideos({ data, isLoading: loading , onUnarchiveVideo , onAddToReport })
  };
}

export function useProductList() {
  const { data, loading } = useQuery(GetProducts);
  const ownedProducts =
    (!loading && data && data.stores && data.stores.ownedProducts) || [];
  const partneredProducts =
    (!loading && data && data.accounts && data.accounts[0].partneredProducts) ||
    [];
  const products = [...ownedProducts, ...partneredProducts];

  return {
    loading,
    products
  };
}

export function useFilters(selectedTab) {
  const [filters, setFilters] = useState({});
  const { data: unfilteredVideosData, loading } = useQuery(
    GetUnfilteredVideos,
    {
      variables: {
        scheduleStatus: selectedTab === "broadcasts" ? "Enabled" : "Disabled"
      }
    }
  );
  const filterOptions = buildFilterOptions({
    videos: unfilteredVideosData
  });
  return { filterOptions, filters, setFilters, loading };
}
